import { Suspense as ReactSuspense, StrictMode } from 'react';
import { SentryProvider } from '@shared/global/sentry';
import { AuthProvider } from '@shared/global/auth/';
import '@shared/styles/index.css';
import { createRoot } from 'react-dom/client';
import { Suspense } from '@core/suspense';

import App from './app';

fetch(`${import.meta.env.VITE_BASE_PATH}/version.json`)
  .then((version) => version.json())
  .then((data) => {
    console.info('🚀 - Starting the app with env:', import.meta.env.VITE_ENV_NAME, data);
  });

createRoot(document.getElementById('root')!).render(
  <SentryProvider>
    <StrictMode>
      <ReactSuspense fallback={<Suspense />}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ReactSuspense>
    </StrictMode>
  </SentryProvider>,
);
